<script lang="ts">
    import IconDelete from './icons/ClosePopUpMessage.svelte';
    export let message: string;
    export let onClosePopUpMessage = () => {}
</script>

<!-- <div style="bottom: 50px; position: relative; margin: auto; width: 50px; background-color: red; border-radius: 20px;"> -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div 
    style="bottom: 0px; position: absolute; display: flex; justify-content: center; width: 100%"
    on:click={onClosePopUpMessage}
>
    <div style="background-color: #fce5a5; border-radius: 20px; padding: 10px; display: flex; justify-content: center; flex-direction: row;">
        {message}
        <span style="width: 20px;"></span>
        <span>
            <IconDelete />
        </span>
    </div>
</div>